import React from 'react';
import { formatListingCategoryLabel } from '../constants/listingCategories';
import {
  LISTING_CONDITION_OPTIONS,
  LISTING_SELLER_TYPE_OPTIONS,
} from '../utils/homeBrowseFilters';

export interface HomeBrowseFilterDraft {
  minPrice: string;
  maxPrice: string;
  condition: string;
  sellerType: string;
  category: string;
}

type Props = {
  draft: HomeBrowseFilterDraft;
  onChange: (patch: Partial<HomeBrowseFilterDraft>) => void;
  categories: string[];
};

/** Mobile home filter sheet — matches buyer app (price, condition, seller, category). */
const HomeBrowseFilterFields: React.FC<Props> = ({ draft, onChange, categories }) => (
  <div className="space-y-4">
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1.5">Price</label>
      <div className="grid grid-cols-2 gap-2">
        <input
          type="number"
          inputMode="decimal"
          value={draft.minPrice}
          onChange={(e) => onChange({ minPrice: e.target.value })}
          placeholder="Min"
          min={0}
          className="w-full box-border rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-1 focus:ring-green-500"
        />
        <input
          type="number"
          inputMode="decimal"
          value={draft.maxPrice}
          onChange={(e) => onChange({ maxPrice: e.target.value })}
          placeholder="Max"
          min={0}
          className="w-full box-border rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-1 focus:ring-green-500"
        />
      </div>
    </div>

    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1.5">Condition</label>
      <select
        value={draft.condition}
        onChange={(e) => onChange({ condition: e.target.value })}
        className="w-full box-border rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-1 focus:ring-green-500"
      >
        {LISTING_CONDITION_OPTIONS.map((opt) => (
          <option key={opt.value || 'all'} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>

    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1.5">Seller type</label>
      <select
        value={draft.sellerType}
        onChange={(e) => onChange({ sellerType: e.target.value })}
        className="w-full box-border rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-1 focus:ring-green-500"
      >
        {LISTING_SELLER_TYPE_OPTIONS.map((opt) => (
          <option key={opt.value || 'all'} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>

    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1.5">Category</label>
      <select
        value={draft.category}
        onChange={(e) => onChange({ category: e.target.value })}
        className="w-full box-border rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-green-500 focus:outline-none focus:ring-1 focus:ring-green-500"
      >
        <option value="">All categories</option>
        {categories.map((cat) => (
          <option key={cat} value={cat}>
            {formatListingCategoryLabel(cat)}
          </option>
        ))}
      </select>
    </div>
  </div>
);

export default HomeBrowseFilterFields;
